import { render, staticRenderFns } from "./MessagesMenu.vue?vue&type=template&id=451b56c0"
import script from "./MessagesMenu.vue?vue&type=script&lang=js"
export * from "./MessagesMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports